import { AnyAction } from 'redux';
import { ActionTypes } from '../constants/index';
import { MasterReasonManagement } from '../modal';

export default function reducer(state: MasterReasonManagement = new MasterReasonManagement(), action: AnyAction) {
  const { type, payload } = action;
  switch (type) {
    case ActionTypes.MASTER_REASON_MGMT_REQUEST:
      return {
        ...state,
        loadingInProgress: true,
      };
    case ActionTypes.MASTER_REASON_MGMT_SUCCESS:
      return {
        ...state,
        loadingInProgress: false,
        data: payload,
      };
    case ActionTypes.MASTER_REASON_MGMT_ERROR:
      return {
        ...state,
        loadingInProgress: false,
        loadingError: payload,
      };
    default:
      return state;
  }
}
